import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TreeViewComponent } from './treeview.component';
/**
 * NgModule definition for the TreeView component.
 */
export class TreeViewModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [
        TreeViewComponent
    ],
    exports: [
        TreeViewComponent
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TreeViewModule_tsickle_Closure_declarations() {
/** @type {?} */
TreeViewModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TreeViewModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
